import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import navyadoc from '../../../../assets/images/Doctorsimages/navyadr.png'
import favicon from "../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const NavyaDoc = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Dr. Navya Annamaneni | Consultant Doctor in Guntur, Andhra Pradesh | Hcura Multispeciality Clinic";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. Navya Annamaneni (BDS), Consultant Doctor at Hcura Multispeciality Clinic, Guntur, Andhra Pradesh. Specialising in dental care and aesthetic treatments, she delivers honest, predictable, and patient-focused care. Book today."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "consultant doctor in Guntur Andhra Pradesh, dental and aesthetic doctor Guntur, BDS doctor in Guntur, dental treatment in Guntur, aesthetic treatment Guntur, skin and dental care Guntur, honest doctor in Guntur, oral health care Guntur, Hcura Guntur clinic"
      );
    }

    const existingCanonical = document.querySelector("link[rel='canonical']");
    const canonicalHref = "https://www.h-cura.com/doctors/dr-navya-annamaneni-dentist-asthetic-guntur-andhrapradesh";
    if (existingCanonical) {
      existingCanonical.setAttribute("href", canonicalHref);
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", canonicalHref);
      document.head.appendChild(canonicalLink);
    }

    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    container.classList.add('veenadoc-pdf-mode');

    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');
    
    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    const images = container.querySelectorAll('img');
    images.forEach(img => { img.style.opacity = '1'; });

    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
      }).then(canvas => {
        container.classList.remove('veenadoc-pdf-mode');
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        });

        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const marginLeft = 10;
        const marginRight = 10;
        const availableWidth = pdfWidth - marginLeft - marginRight;
        const scaleFactor = availableWidth / canvas.width;
        const imgWidth = canvas.width * scaleFactor;
        const imgHeight = canvas.height * scaleFactor;
        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }
        pdf.save('Dr.Navya_Annamaneni_Profile.pdf');
      });
    }, 100);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Navya Annamaneni</span>
                  <span className="veenadoc-title-credentials">(BDS)</span>
                  <span className="veenadoc-title-location">Guntur, Andhra Pradesh</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    A dedicated Consultant Doctor at Hcura Multispeciality Clinic in Guntur, Andhra Pradesh. 
                    Practising across both dental and aesthetic care, she offers patients a trusted single point of contact 
                    for comprehensive healthcare with a focus on honest and predictable outcomes.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={navyadoc} alt="Dr. Navya Annamaneni, BDS, Consultant Doctor in Guntur, Andhra Pradesh" className="veenadoc-doctor-image" title='Dr. Navya Annamaneni – Consultant Doctor at Hcura Multispeciality Clinic Guntur' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">
                
                <div className="veenadoc-article-block">
                  <h2>About Dr. Navya Annamaneni</h2>
                  <p>
                    Dr. Navya Annamaneni (BDS) completed her Bachelor of Dental Surgery from the Kamineni Institute of Dental Sciences. 
                    Known for her strong academic foundation and practical skill, she has built a reputation in <strong>Andhra Pradesh </strong> 
                     for providing straightforward and patient-focused care.
                  </p>
                  <p>
                    She is a valuable resource for patients in Guntur who prefer to manage multiple health and aesthetic concerns 
                    with one trusted doctor they know and feel comfortable with.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Clinical Foundation & Experience</h2>
                  <p>
                    Before joining Hcura in Guntur, Andhra Pradesh, Dr. Navya built her clinical foundation at <strong>Crowns Aesthetics</strong> in Hyderabad. 
                    This experience gave her early exposure to high-quality dental and aesthetic outcomes, where results must be 
                    both clinically sound and visually refined.
                  </p>
                  <p>
                    Her background has shaped her approach to every procedure, focusing not just on medical correctness but 
                    on what will genuinely satisfy the patient in their everyday life.
                  </p>
                </div>
                 <div className="veenadoc-article-block">
                  <h2>Specialized Trichology & Hair Care Solutions</h2>
                  <p>
                    Dr. Navya has gained recognition as a trichology doctor in Guntur specializing in hair fall,  dandruff, scalp conditions, hair thinning, premature greying, alopecia, and hair regrowth treatments. She also provides advanced hair therapies such as PRP (Platelet-Rich Plasma), GFC (Growth Factor Concentrate), Mesotherapy, Stem Cell Therapy, Laser Hair Therapy and exosome  to ensure effective and long-lasting results.
                  </p>
                  <p>
                    Her expertise ensures that patients not only regain healthy hair but also confidence and peace of mind.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BDS</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Dental & Aesthetics</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Location:</span>
                      <span className="veenadoc-info-value">Guntur, Andhra Pradesh</span>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Honest Care & Predictable Outcomes</h2>
                  <p>
                    Dr. Navya’s philosophy is simple: every patient deserves a truthful picture of their condition. 
                    At Hcura Guntur, Andhra Pradesh, she ensures there are no surprises or unnecessary procedures. 
                    She takes deliberate care to explain each step of the procedure, especially for those with dental anxiety.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Comprehensive Dental & Aesthetic Services</h2>
                  <p>
                    From routine checkups, teeth cleaning, and extractions to advanced restorative procedures and aesthetic 
                    consultations, Dr. Navya brings precision and a patient-first mindset to every case. She measures success 
                    by the confidence and satisfaction of the patient walking out of the clinic.
                  </p>
                </div>

                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>A Reliable Choice in Guntur, Andhra Pradesh</h2>
                  <p>
                    At Hcura Multispeciality Clinic in Guntur, Dr. Navya is part of a team that brings dental, aesthetic, 
                    homeopathy, skin, and hair care together under one roof. For patients across <strong>Andhra Pradesh</strong>, 
                    she represents a blend of clinical skill and honest communication.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To provide honest, skilled, and consistent care from start to finish, ensuring predictable outcomes for every patient.
                  </p>
                </div>
              </div>

              <div className="veenadoc-article-sidebar">
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote style={{ fontSize: '1.2rem' }}>
                      "I aim for honest care and predictable outcomes."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Navya Annamaneni's Philosophy</p>
                  </div>
                  <p>
                    She believes in giving a realistic understanding of results, ensuring every patient is informed and at ease.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Guntur, Andhra Pradesh</h4>
                      <p>Hcura Multispeciality Clinic</p>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience predictable and honest healthcare with Dr. Navya in Guntur.</p>
                  <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                  <button className="veenadoc-sidebar-btn-secondary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>💬</span>
                    <span>Get Free Assessment</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow />

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download Dr. Navya's Profile (PDF)
        </button>
      </div>
    </>
  )
}

export default NavyaDoc
